import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Load } from './'
import { ButtonStyle } from './../styles'

export default class Button extends Component {
  state = {
    isLoaded: false,
  }

  handlerClick = (e) => {
    e.preventDefault()
    if (this.props.withLoad) this.setState({isLoaded: true}) 
    this.props.onCallback().then(() => {
      this.setState({isLoaded: false}) 
    }).catch((err) => {
      console.log('Something wrong with callback.')
    })
  }

  static defaultProps = {
    withLoad: true,
    theme: 'grey',
    type: 'button',
  }

  render() {
    const { theme, withLoad, children, type, className } = this.props
    const { isLoaded } = this.state
    return(
      <button onClick={this.handlerClick} type={type} className={`${className} btn ${ButtonStyle(theme, isLoaded)}`}>
        { 
          withLoad && (
            <span className="btn--load">
              <Load width="25" height="25" />
            </span>
          )
        }
        <span className="btn--label">
          { children }
        </span>
      </button>
    )
  }
}

Button.propTypes = {
  theme : PropTypes.string.isRequired,
  withLoad: PropTypes.bool,
  children: PropTypes.node,
  type: PropTypes.string,
}


// WEBPACK FOOTER //
// ./src/components/Button.js